import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { Panel } from 'primeng/panel';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ORGANIZACJA_APPLICATION_LIST } from '../application-cards/application-filters-definition';
import { ApplicationCode } from '../../shared/enums/application_code';
import { Application } from '../../shared/models/application';
import { ApplicationService } from '../../shared/services/application.service';

@Component({
  selector: 'app-organization-create-info',
  imports: [Panel, Button, TooltipModule],
  templateUrl: './organization-create-info.component.html',
  styleUrl: './organization-create-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationCreateInfoComponent {
  public firstPanelToggled = signal(true);
  public secondPanelToggled = signal(true);

  protected readonly ApplicationCode = ApplicationCode;

  readonly #applicationService = inject(ApplicationService);

  protected navigateToApplication(applicationCode: ApplicationCode): void {
    const application = ORGANIZACJA_APPLICATION_LIST.find(
      (application: Application) => application.kod === applicationCode,
    );
    if (application) {
      this.#applicationService
        .initApplicationFlowWithUnit(application)
        .subscribe();
    }
  }

  public onCollapsedFirstPanelChange($event: boolean | undefined): void {
    this.firstPanelToggled.set($event!);
  }

  public onCollapsedSecondPanelChange($event: boolean | undefined): void {
    this.secondPanelToggled.set($event!);
  }
}
